import taxSettingsReducer from "./taxSettingsSlice";

export default taxSettingsReducer;
